export default __webpack_public_path__ + "static/media/concept1.29e15dbb.png";